import { render } from "./ProductEdit.vue?vue&type=template&id=ceeba124"
import script from "./ProductEdit.vue?vue&type=script&lang=js"
export * from "./ProductEdit.vue?vue&type=script&lang=js"

import "./ProductEdit.vue?vue&type=style&index=0&id=ceeba124&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__